<template>
  <div>
    <div class="card card-body p-0" style="border-radius: 10px">
      <faq-table :FAQs="FAQs" :totalPages="totalPages" :page="page" @setPage="setPage" @setCategory="setCategory" :setSkeletonLoader="displayLoader"></faq-table>
    </div>
  </div>
</template>

<script>
  import Loading from "vue-loading-overlay";
  import helpers from "@/helpers.js";
  import FAQTable from "./faq_table";
  import VueSkeletonLoader from 'skeleton-loader-vue';
  export default {
    components: {
      "faq-table": FAQTable,VueSkeletonLoader,
      Loading,
    },
    data: function () {
      return {
        page: 0,
        category: '',
        fullPage: "",
        displayLoader: true,
      };
    },
    computed: {
      FAQs: function () {
        return this.$store.getters["faqs/FAQs"];
      },
      totalPages: function () {
        return this.$store.getters["faqs/totalPages"];
      },
    },
    created: function () {
      this.page = helpers.getPageQuery();
      this.$store.dispatch('faqcategories/getAllCategories');
    },
    watch: {
      page: function (val) {
        this.setSkeletonLoader(true);
        this.$store.dispatch("faqs/getAllFAQs", [val, this.category, ""])
        .then(()=>{
          setTimeout(() => {
            this.setSkeletonLoader(false);
          }, 500);
         
        });
       
      },
    },
    methods: {
      setPage(page) {
        this.page = page;
        // this.$router.push("faqs?page=" + page);
      },
      setCategory(category){
        console.log("cat =>", category || '');
        this.category = category || ''
      },
      setSkeletonLoader(val){
        this.displayLoader = val;
        this.$forceUpdate();
      },
    },
  };
</script>
<style>
  .custom {
    position: absolute;
    z-index: 999;
    top: 246px;
    left: 40%;
    opacity: 0.5;
  }
</style>